import { PlyrComponent } from 'plyr-react';
import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';

const VideoPresentation = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('videos')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    const longue = {
        type: 'video',
        sources: [
            {
                src: '429970682',
                provider: 'vimeo',
            },
        ]
    }

    const courte = {
        type: 'video',
        sources: [
            {
                src: '430732393',
                provider: 'vimeo',
            },
        ]
    }

    return (
        <div>
            <h1>Présentation de l'organisation de l'UV</h1>
            <p>Dans cette vidéo, le responsable de l'UV vous présente en détail l'organisation de l'UV (les TD, les horaires, les cours, etc).</p>
            <PlyrComponent sources={courte} />
            <div className="button-container">
                <Button icon="arrow-left" to="?page=videos">Toutes les vidéos</Button>
                <Button icon="arrow-right" to="?page=videos&id=modalites">Modalités d'obtention de l'UV</Button>
            </div>
        </div>
    );
}

export default VideoPresentation;